const getters = {
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    routes: state => state.user.routes,
    role: state => state.user.role,
    permission_routes: state => state.user.routes,
    unreadMessages: state => state.user.unreadMessages,
    totalUnread: (state) => state.user.totalUnread,
    orderInfo: (state) => state.user.orderInfo,
  }
  export default getters
  